import axios from 'axios';
import { BASE_URL } from '../config/apiUrls';

// Base API configuration
const api = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// API with token configuration
export const apiWithToken = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor for apiWithToken
apiWithToken.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
const responseInterceptor = (response) => {
  return response;
};

const errorInterceptor = (error) => {
  // Xử lý response với code 401 hoặc status 401
  if (error.response?.status === 401 || error.response?.data?.code === 401) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    // Chỉ redirect nếu không phải đang ở trang login
    if (window.location.pathname !== '/login') {
      window.location.href = '/login';
    }
  }
  return Promise.reject(error);
};

api.interceptors.response.use(responseInterceptor, errorInterceptor);
apiWithToken.interceptors.response.use(responseInterceptor, errorInterceptor);

export default api;

